import { apiClient, ApiError } from './apiClient';

class TokenValidator {

  validateResetToken(token, email) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await apiClient.post('/api/users/validate-reset-token', { token, email });

        resolve({
          valid: true,
          expiresAt: data.expiresAt,
          remainingTime: data.remainingTime
        });

      } catch (error) {
        if (error instanceof ApiError) {
          reject({
            valid: false,
            error: (error.body && error.body.message) || 'Token validation failed',
            expired: (error.body && error.body.expired) || false,
            code: error.status
          });
          return;
        }
        reject({
          valid: false,
          error: 'Network error during token validation',
          expired: false
        });
      }
    });
  }

  async checkTokenExpiration(token, email) {
    try {
      const result = await this.validateResetToken(token, email);
      
      if (result.remainingTime <= 0) {
        return {
          expired: true,
          message: 'This password reset link has expired. Please request a new one.'
        };
      }
      
      if (result.remainingTime < 5 * 60 * 1000) { // Less than 5 minutes
        return {
          expired: false,
          warning: true,
          message: `This link will expire in ${Math.ceil(result.remainingTime / 60000)} minutes.`
        };
      }
      
      return {
        expired: false,
        warning: false,
        message: 'Token is valid'
      };
      
    } catch (error) {
      return {
        expired: error.expired || true,
        message: error.error || 'Invalid or expired reset link'
      };
    }
  }

  formatTimeRemaining(milliseconds) {
    if (milliseconds <= 0) return '0 minutes';
    
    const minutes = Math.ceil(milliseconds / 60000);
    const hours = Math.floor(minutes / 60);
    
    if (hours > 0) {
      const remainingMinutes = minutes % 60;
      return `${hours} hour${hours > 1 ? 's' : ''}${remainingMinutes > 0 ? ` and ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}` : ''}`;
    }
    
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  }

  isTokenFormat(token) {
    // Check if token matches expected format (adjust regex as needed)
    const tokenRegex = /^[a-f0-9]{64}$/i; // Assuming 64-character hex token
    return tokenRegex.test(token);
  }

  sanitizeToken(token) {
    // Remove any non-alphanumeric characters except hyphens and underscores
    return token.replace(/[^a-zA-Z0-9\-_]/g, '');
  }

  generateSecureToken() {
    // Generate a cryptographically secure token
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
  }
}

const tokenValidator = new TokenValidator();
export default tokenValidator;